import { LevelEditorModeEnum } from '../shared';
import { BackgroundCategoryString, RecentsCategoryString } from '../../GameKit/shared';
import LibraryManager from '../../Game/Base/Library/LibraryManager';

const defaultState = {
    mode: LevelEditorModeEnum.DEFAULT,
    prevMode: LevelEditorModeEnum.DEFAULT,
    itemSelectorOpen: false,
    itemSelectorCurrentCategory: "",
    backgroundEditorTileId: "",
    hoveredPrefabName: ""
};

function toggleItemSelector(state, open, newCategory = "") {
    return {
        ...state,
        itemSelectorOpen: open,
        itemSelectorCurrentCategory: newCategory
    }
}

function openNewMode(state, mode) {
    const newState = state;

    if(mode === LevelEditorModeEnum.MOVE) {
        // Only toggle between previous modes if the MOVE mode is toggled off
        if(newState.mode === LevelEditorModeEnum.MOVE) {
            const curMode = newState.mode;
            newState.mode = newState.prevMode;
            newState.prevMode = curMode;
        }
        // Set prev mode to current mode if MOVE mode is toggled on
        else {
            const curMode = newState.mode;
            newState.mode = mode;
            newState.prevMode = curMode;
        }
    }
    // If the toggled mode is anything else than move, just switch between the given mode and DEFAULT
    else {
        newState.mode = newState.mode === mode ? LevelEditorModeEnum.DEFAULT : mode;
    }

    return {
        ...newState,

    };
}


export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'ITEM_SELECTOR_TOGGLE': {
            let firstCategory = state.itemSelectorCurrentCategory;
            if(state.itemSelectorCurrentCategory.trim().length === 0 && LibraryManager.textures._categories.length > 0) {
                firstCategory = LibraryManager.prefabs._categories[0].title;
            }

            const displayCategory = (
                state.mode === LevelEditorModeEnum.BACKGROUND && !state.itemSelectorOpen
                ? BackgroundCategoryString 
                : firstCategory
            );
            return toggleItemSelector(state, !state.itemSelectorOpen, displayCategory);
        }
        case 'ITEM_SELECTOR_OPEN_CATEGORY': {
            return {
                ...state,
                itemSelectorCurrentCategory: action.payload,
            };
        }
        case 'ITEM_SELECTOR_OPEN_RECENTS': {
            return {
                ...state,
                itemSelectorCurrentCategory: RecentsCategoryString,
            };
        }
        case 'LEVEL_EDITOR_TOGGLE_MOVE': {            
            let newState = openNewMode(state, LevelEditorModeEnum.MOVE);
            
            newState = toggleItemSelector(newState, newState.mode !== LevelEditorModeEnum.MOVE, state.itemSelectorCurrentCategory);
            
            return {
                ...newState
            };
        }
        case 'LEVEL_EDITOR_TOGGLE_BACKGROUND': {
            const displayCategory = state.mode === LevelEditorModeEnum.BACKGROUND ? state.itemSelectorCurrentCategory : BackgroundCategoryString;
            let newState = toggleItemSelector(state, true, displayCategory);

            newState = openNewMode(newState, LevelEditorModeEnum.BACKGROUND);

            if(newState.backgroundEditorTileId.trim() === "") {
                const library = LibraryManager.textures;
                if(library._categories.length > 0) {
                    if(library._categories[0]._items.length > 0) {
                        newState.backgroundEditorTileId = library._categories[0]._items[0].id;
                    }
                }

            }
            if(newState.backgroundEditorTileId.trim() === "") {
                throw ("LevelEditorReducer couldn't find a default texture for the background editor!");
            }

            return {
                ...newState
            };
        }
        case 'LEVEL_EDITOR_BG_SET_TILE_ID': {
            return {
                ...state,
                backgroundEditorTileId: action.payload
            }
        }
        case 'LEVEL_EDITOR_PREFAB_HOVER': {
            return {
                ...state,
                hoveredPrefabName: action.payload
            }
        }
        default: {
            return state;
        }
    }
}
